module.exports = __webpack_public_path__ + "media/images/flags/az-d4faca473814e47b3f03fd7c83e72ad1.svg";